import { IVector3 } from './gameplay';

export enum JobFinishReason {
	PlayerLeft = 'PlayerLeft',
	PlayerDied = 'PlayerDied',
	PlayerPossiblyCheating = 'PlayerPossiblyCheating',
	VehicleDestroyed = 'VehicleDestroyed',
	VehicleNotExists = 'VehicleNotExists',
	InternalError = 'InternalError',
	TimeoutExpired = 'TimeoutExpired',
	StartingConditionsNotMet = 'StartingConditionsNotMet',
}

export enum Job {
	Farmer = 'farmer',
	Taxi = 'taxi',
	Courier = 'courier',
	Bus = 'bus',
	PizzaDelivery = 'pizza_delivery',
	Electrician = 'electrician',
	Post = 'post',
}

export interface IJobDescription {
	text: string;
	pics: string[];
}

export interface ITaxiCustomer {
	pickupPosition: IVector3;
	customersPositions: [IVector3, IVector3, IVector3] | null;
	dropoffPosition: IVector3;
}

export interface IBusRoutePoint {
	position: IVector3;
	passengerPositions: [IVector3, IVector3, IVector3, IVector3] | null;
}

export enum BusGameplayState {
	GoToNextBusStop = 'go_to_next_bus_stop',
	AtBusStop = 'at_bus_stop',
	WaitForBoardingProgress = 'wait_for_boarding_progress',
	WaitForUnboardingProgress = 'wait_for_unboarding_progress',
}

export interface IJobsConfig<T extends Job> {
	jobId: T;
	title: string;
	wordForms: [string, string, string];
	descShort: string;
	desc: IJobDescription[];
}

export type JobSelectedVehicle =
	| {
			modelOrId: string;
			owned: boolean;
	  }
	| undefined;
